/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Remove_Event_TitleInputs */



/**
* | output |
* | --- |
* | "Remove Event(s)" |
*
* @param {Remove_Event_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const remove_event_title = /** @type {((inputs?: Remove_Event_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remove_Event_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer Evenement(s)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignis(se) entfernen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi evento/i")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить событие(я)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar evento(s)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("移除事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントを削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट हटाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remover evento(s)")
	return /** @type {LocalizedString} */ ("Remove Event(s)")
});